import { render } from "./WguApp.vue?vue&type=template&id=2e57917b"
import script from "./WguApp.vue?vue&type=script&lang=js"
export * from "./WguApp.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__